import "./styles.scss";
import { observer } from "mobx-react";
import React, { useEffect, useRef } from 'react';
import { useMedia, useStore } from 'shared/hooks';
import { profileDashboardStore } from './../../../../store/ProfileDashBoardStore';
import { PPDWidgetRatingLeagueList } from './components/PPDWidgetLeagueRatingList';
import { PPDWidgetLeagueRatingSubTabs } from './components/PPDWidgetLeagueRatingSubTabs';
import { PPDWidgetLeagueRatingTabs } from './components/PPDWidgetLeagueRatingTabs';
import { PPDWidgetLeagueRatingModal } from './components/PPDWidgetLeagueRatingModal';
import { UserDashboardWidgetModel } from 'shared/models';

type Props = {
    widget: UserDashboardWidgetModel
    onOpenLeagueInfo?: () => void;
};
export const PPDWidgetLeagueRating = observer(({ widget, onOpenLeagueInfo }: Props) => {

    const listRef = useRef<HTMLUListElement | null>(null);
    const itemRefs = useRef<Record<number, HTMLLIElement | null>>({});
    const { isMobileOrTablet } = useMedia()

    const pageStore = profileDashboardStore;

    const store = useStore(() => ({
        subtab: "leaders" as "leaders" | "my_place",
        isOpenLeagueRatingModal: false,
    }));

    const list = widget[pageStore.activeLeagueTab].items as any[];

    const MAX_COUNT_ITEMS = isMobileOrTablet ? 4 : 9;
    const isMoreButtonVisible = list.length > MAX_COUNT_ITEMS;

    useEffect(() => {
        if (!listRef.current) return;
        const list = listRef.current;

        if (store.subtab === "leaders") {
            list.scrollTo({ top: 0, behavior: "smooth" });
        } else {

            const currentItem = Object.values(itemRefs.current).find(
                (el) => el?.dataset.current === "true"
            );

            if (currentItem && list) {
                const itemRect = currentItem.getBoundingClientRect();

                const offset =
                    currentItem.offsetTop -
                    list.clientHeight / 2 +
                    itemRect.height / 2;

                list.scrollTo({ top: offset, behavior: "smooth" });
            }
        }
    }, [store.subtab, pageStore.activeLeagueTab]);


    return (
        <div className="ppd-widget-league-rating">
            <div className="ppd-widget-league-rating__header">
                <div className="ppd-widget-league-rating__title-row">
                    <h3 className="ppd-widget-league-rating__title">{widget.name}</h3>
                    <button type="button" className="ppd-widget-league-rating__info-button" onClick={onOpenLeagueInfo}>О рейтинге</button>
                </div>
                <PPDWidgetLeagueRatingTabs
                    activeTab={pageStore.activeLeagueTab}
                    labels={widget.labels}
                    onChange={(tab) => pageStore.setActiveLeagueTab(tab)}
                />
            </div>
            <div className="ppd-widget-league-rating__content">
                <PPDWidgetLeagueRatingSubTabs
                    activeSubtab={store.subtab}
                    labels={widget.labels}
                    onChange={(sub) => store.set("subtab", sub)}
                />
                <PPDWidgetRatingLeagueList
                    list={list}
                    activeTab={pageStore.activeLeagueTab}
                    subtab={store.subtab}
                />
            </div>
            {
                isMoreButtonVisible && (
                    <div className="ppd-widget-league-rating__footer">
                        <button
                            type="button"
                            className="ppd-widget-league-rating__more-button"
                            onClick={() => store.set("isOpenLeagueRatingModal", true)}
                        >
                        Подробнее
                        </button>
                    </div>
                )
            }
            <PPDWidgetLeagueRatingModal
                title={widget.name}
                isOpen={store.isOpenLeagueRatingModal}
                onClose={() => store.set("isOpenLeagueRatingModal", false)}
                list={list}
                activeTab={pageStore.activeLeagueTab}
                activeSubtab={store.subtab}
                onChangeTab={(tab) => pageStore.setActiveLeagueTab(tab)}
                onChangeSubtab={(sub) => store.set("subtab", sub)}
                labels={widget.labels}
            />
        </div>
    );
});
